import { AppStyle } from './appStyle';
import { env } from '../env';

export const basePath: string = env.VITE_API_URL;
export const basePathWithApi: string = basePath + '/api/v1.16';
export const filesUri: string = basePathWithApi + '/Files';
export const imagesUri: string = filesUri + '/images';
export const refreshTokenUri: string = basePathWithApi + '/Customers/refreshToken';

export const apiKey: string = env.VITE_API_KEY;

export const appStyleMode: AppStyle =
  env.VITE_APP_TYPE === 'mobile'
    ? AppStyle.Mobile
    : env.VITE_COMPANY_NAME === 'FORMADA'
      ? AppStyle.Formada
      : env.VITE_COMPANY_NAME === 'Linos Artelė'
        ? AppStyle.LinosArtele
        : AppStyle.Website;

export const CompanyName: string = env.VITE_COMPANY_NAME;
export const CompanyRegistered: string = env.VITE_COMPANY_REGISTERED;
export const CompanyTitle: string = env.VITE_OG_TITLE;
export const SiteName: string = env.VITE_OG_SITE_NAME;
export const AppUrl: string = env.VITE_OG_URL;
export const IsSewingCompany: boolean = appStyleMode === AppStyle.Formada || appStyleMode === AppStyle.LinosArtele;
export const IsGtagEnabled: boolean = !!env.VITE_GOOGLE_TAG_ID;

export const ExternalLoginPrefix: string = env.VITE_EXTERNAL_LOGIN_PREFIX;
export const FacebookUrl: string = env.VITE_LINK_FACEBOOK;
export const InstagramUrl: string = env.VITE_LINK_INSTAGRAM;
export const YoutubeUrl: string = env.VITE_LINK_YOUTUBE;
